/**
 * expires_atから残り日数と時間を計算する
 * バックエンドのexpires_atはUTC（タイムゾーンなし）で保存されている
 * @param {string|Date} expireAt - 有効期限 (UTC)
 * @returns {{ days: number, hours: number, minutes: number, isUnderOneHour: boolean, isExpired: boolean }}
 */
export function getRemainingTime(expireAt) {
    const expired = { days: 0, hours: 0, minutes: 0, isUnderOneHour: false, isExpired: true };

    if (!expireAt) return expired;

    const now = new Date();
    const expireStr = typeof expireAt === 'string' && !expireAt.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(expireAt)
        ? expireAt + 'Z'
        : expireAt;
    const expire = new Date(expireStr);

    if (Number.isNaN(expire.getTime())) return expired;

    const diffMs = expire.getTime() - now.getTime();

    if (diffMs <= 0) return expired;

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const totalHours = Math.floor(totalMinutes / 60);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = totalMinutes % 60;

    return { days, hours, minutes, isUnderOneHour: totalHours < 1, isExpired: false };
}
